import FormAddress          from "./forms/form-address.vue";
import FormCommunication    from "./forms/form-communication.vue";
import FormNotification     from "./forms/form-notification.vue";
export default {
    components: {
        FormAddress,
        FormCommunication,
        FormNotification
    },
    props: {
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
        warrantyDecisionCases   : {
            type    : Object,
            default : function () { return {}; }
        }
    },
    data: () => ({
        panels                      : [0],
        panelCustomerAddressOpened  : true,
        panelBillAddressOpened      : true,
        panelDeliveryAddressOpened  : true,

        showChechboxAdditionalAddresses: true,

        showFormCustomerAddress      : true,
        showFormBillAddress          : false,
        showFormDeliveryAddress      : false,
        showNotification             : false,

        checkboxBill                : false,
        checkboxDelivery            : false,

        billAddressStatus           : false,
        deliveryAddressStatus       : false,

        formCustomerAddress         : null,
        formBillAddress             : null,
        formDeliveryAddress         : null,
        formCustomerCommunication   : null,

        formCustomerAddressHasErrors    : false,
        formBillAddressHasErrors        : false,
        formDeliveryAddressHasErrors    : false,
        formNotificationErrors          : false,

        btnDeliveryAddress   : null,
        btnBillAddress       : null,

        formCustomerCommunicationErrors     : false,
        formBillCommunicationHasErrors      : false,
        formDeliveryCommunicationHasErrors  : false,

    }),
    methods: {
        onCheckboxBillChange() {
            this.showFormBillAddress = !this.showFormBillAddress;
            this.billAddressStatus = !this.billAddressStatus;
            this.$refs.formBillAddress.resetForm();
        },
        onCheckboxDeliveryChange() {
            this.showFormDeliveryAddress = !this.showFormDeliveryAddress;
            this.deliveryAddressStatus = !this.deliveryAddressStatus;
            this.$refs.formDeliveryAddress.resetForm();
        },
        onBillAddressBtnClick() {
            let formCustomerAddressValues       = this.$refs.formCustomerAddress.getFormValues();
            let formCustomerCommunicationValues = this.$refs.formCustomerCommunication.getFormValues();
            this.$refs.formBillAddress.setFormValues(formCustomerAddressValues);
            this.$refs.formBillCommunication.setFormValues(formCustomerCommunicationValues);
        },
        onDeliveryAddressBtnClick() {
            let formCustomerAddressValues       = this.$refs.formCustomerAddress.getFormValues();
            let formCustomerCommunicationValues = this.$refs.formCustomerCommunication.getFormValues();
            this.$refs.formDeliveryAddress.setFormValues(formCustomerAddressValues);
            this.$refs.formDeliveryCommunication.setFormValues(formCustomerCommunicationValues);

        },
        validateAll() {
            let valid = true;
            if (!this.$refs.formCustomerAddress.validateForm()) {
                valid = false;
            }
            if (!this.$refs.formCustomerCommunication.validateForm() ) {
                valid = false;
            }
            if (this.warrantyDecisionCases.businessCode == 1 || this.warrantyDecisionCases.businessCode == 0) {
                if (!this.$refs.formNotification.validateForm() ) {
                    valid = false;
                }
            }
            if (this.checkboxBill) {
                if (!this.$refs.formBillAddress.validateForm()) {
                    valid = false;
                }
            }
            if (this.checkboxDelivery) {
                if (!this.$refs.formDeliveryAddress.validateForm()) {
                    valid = false;
                }
            }
            return valid;
        },
        validateFormCustomer() {
            this.$refs.formCustomerAddress.validateForm();
            this.$refs.formCustomerCommunication.validateForm();
        },
        getStepData() {
            let ret = {};

            ret.formCustomerAddress         = this.$refs.formCustomerAddress.getFormValues();
            ret.formCustomerAddress.communication   = this.$refs.formCustomerCommunication.getFormValues();
            if (this.checkboxBill) {
                ret.formBillAddress         = this.$refs.formBillAddress.getFormValues();
                ret.formBillAddress.communication   = this.$refs.formBillCommunication.getFormValues();
            }
            if (this.checkboxDelivery) {
                ret.formDeliveryAddress         = this.$refs.formDeliveryAddress.getFormValues();
                ret.formDeliveryAddress.communication   = this.$refs.formDeliveryCommunication.getFormValues();
            }
            return ret;
        },
        //data to be collected on the last step. This data will be send to db
        getStepSubmitData() {
            let ret = {};
            console.info('refs', this.$refs);

            if (this.$refs.formCustomerAddress && this.$refs.formCustomerCommunication) {
                let formCustomerAddress         = this.$refs.formCustomerAddress.getFormValues();
                let formCustomerCommunication   = this.$refs.formCustomerCommunication.getFormValues();
                let customerAddress = {};

                customerAddress.type        = formCustomerAddress.radiosAddressType;
                customerAddress.title       = formCustomerAddress.radiosAddressTitle;
                customerAddress.company     = formCustomerAddress.fieldCompany;
                customerAddress.department  = formCustomerAddress.fieldDepartment;
                customerAddress.firstName   = formCustomerAddress.fieldFirstname;
                customerAddress.lastName    = formCustomerAddress.fieldLastname;
                customerAddress.street      = formCustomerAddress.fieldStreet;
                customerAddress.country     = formCustomerAddress.selectCountry;
                customerAddress.zipCode     = formCustomerAddress.fieldZipCode;
                customerAddress.city        = formCustomerAddress.fieldCity;
                customerAddress.language    = formCustomerAddress.selectLanguage;
                customerAddress.phone       = formCustomerCommunication.numTelefon;
                customerAddress.fax         = formCustomerCommunication.numFax;
                customerAddress.mobile      = formCustomerCommunication.numMobile;
                customerAddress.email       = formCustomerCommunication.email;

                ret.customerAddress = customerAddress;
            }
            if (this.$refs.formBillAddress && this.$refs.formBillCommunication) {
                let formBillddress              = this.$refs.formBillAddress.getFormValues();
                let formBillCommunication       = this.$refs.formBillCommunication.getFormValues();
                let billingAddress = {};

                billingAddress.type        = formBillddress.radiosAddressType;
                billingAddress.title       = formBillddress.radiosAddressTitle;
                billingAddress.company     = formBillddress.fieldCompany;
                billingAddress.department  = formBillddress.fieldDepartment;
                billingAddress.firstName   = formBillddress.fieldFirstname;
                billingAddress.lastName    = formBillddress.fieldLastname;
                billingAddress.street      = formBillddress.fieldStreet;
                billingAddress.country     = formBillddress.selectCountry;
                billingAddress.zipCode     = formBillddress.fieldZipCode;
                billingAddress.city        = formBillddress.fieldCity;
                billingAddress.language    = formBillddress.selectLanguage;
                billingAddress.phone       = formBillCommunication.numTelefon;
                billingAddress.fax         = formBillCommunication.numFax;
                billingAddress.mobile      = formBillCommunication.numMobile;
                billingAddress.email       = formBillCommunication.email;

                ret.billingAddress = billingAddress;
            }

            if (this.$refs.formBillAddress && this.$refs.formBillCommunication) {
                let formDeliveryAddress         = this.$refs.formDeliveryAddress.getFormValues();
                let formDeliveryCommunication   = this.$refs.formDeliveryCommunication.getFormValues();
                let deliveryAddress = {};

                deliveryAddress.type        = formDeliveryAddress.radiosAddressType;
                deliveryAddress.title       = formDeliveryAddress.radiosAddressTitle;
                deliveryAddress.company     = formDeliveryAddress.fieldCompany;
                deliveryAddress.department  = formDeliveryAddress.fieldDepartment;
                deliveryAddress.firstName   = formDeliveryAddress.fieldFirstname;
                deliveryAddress.lastName    = formDeliveryAddress.fieldLastname;
                deliveryAddress.street      = formDeliveryAddress.fieldStreet;
                deliveryAddress.country     = formDeliveryAddress.selectCountry;
                deliveryAddress.zipCode     = formDeliveryAddress.fieldZipCode;
                deliveryAddress.city        = formDeliveryAddress.fieldCity;
                deliveryAddress.language    = formDeliveryAddress.selectLanguage;
                deliveryAddress.phone       = formDeliveryCommunication.numTelefon;
                deliveryAddress.fax         = formDeliveryCommunication.numFax;
                deliveryAddress.mobile      = formDeliveryCommunication.numMobile;
                deliveryAddress.email       = formDeliveryCommunication.email;

                ret.deliveryAddress = deliveryAddress;
            }
            // //Notifications
            if (this.$refs.formNotification) {
                let formNotification    = this.$refs.formNotification.getFormValues();
                ret.notificationType    = formNotification.type;
                ret.notificationNumber  = formNotification.numTelefon;
                ret.notificationEmail   = formNotification.email;
            }
            if (this.checkboxBill) {
                ret.billingAddressSet = true;
            } else {
                ret.billingAddressSet = false;
            }
            if (this.checkboxDelivery) {
                ret.deliveryAddressSet = true;
            } else {
                ret.deliveryAddressSet = false;
            }

            return ret;
        },
        //TODO: remove this
        setFakeCustomerData() {
            let clientForm  = {};
            let comForm     = {};

            clientForm.radiosAddressType   = 'typeCompany';
            clientForm.radiosAddressTitle  = 'titleMasc';
            clientForm.fieldCompany        = 'WAS.ch gmbH';
            clientForm.fieldDepartment     = 'IT';
            clientForm.fieldFirstname      = 'Martin';
            clientForm.fieldLastname       = 'Dörig';
            clientForm.fieldStreet         = 'Vonwilstrasse 23';
            clientForm.selectCountry       = 'ch';
            clientForm.fieldZipCode        = 9000;
            clientForm.fieldCity           = 'St. Gallen';
            clientForm.selectLanguage      = 'Deutsch';

            this.selectNotificationType    = 1;

            this.$refs.formCustomerAddress.setFormValues(clientForm);

            comForm.numTelefon = '+41 79 888 11 11';
            comForm.numFax     = '+41 79 888 11 22';
            comForm.numMobile  = '+41 79 888 11 33';
            comForm.email      = 'doerig@was.ch';

            this.$refs.formCustomerCommunication.setFormValues(comForm);
        },
        setFakeCustomerDataPrivate() {
            let clientForm  = {};
            let comForm     = {};

            clientForm.radiosAddressType   = 'typePrivate';
            clientForm.radiosAddressTitle  = 'titleMasc';
            clientForm.fieldFirstname      = 'Martin';
            clientForm.fieldLastname       = 'Dörig';
            clientForm.fieldStreet         = 'Vonwilstrasse 23';
            clientForm.selectCountry       = 'ch';
            clientForm.fieldZipCode        = 9000;
            clientForm.fieldCity           = 'St. Gallen';
            clientForm.selectLanguage      = 'Deutsch';

            this.selectNotificationType    = 1;

            this.$refs.formCustomerAddress.setFormValues(clientForm);

            comForm.numTelefon = '+41 79 888 11 11';
            comForm.numFax     = '+41 79 888 11 22';
            comForm.numMobile  = '+41 79 888 11 33';
            comForm.email      = 'doerig@was.ch';

            this.$refs.formCustomerCommunication.setFormValues(comForm);
        },
        getValuesForNotificationForm() {
            let values = {};

            if (this.$refs.formCustomerAddress && this.$refs.formCustomerCommunication) {
                let formCustomerAddress         = this.$refs.formCustomerAddress.getFormValues();
                let formCustomerCommunication   = this.$refs.formCustomerCommunication.getFormValues();

                values.phone  = formCustomerCommunication.numTelefon;
                values.fax    = formCustomerCommunication.numFax;
                values.mobile = formCustomerCommunication.numMobile;
                values.email  = formCustomerCommunication.email;
            }
            return values;
        }
    },
    watch: {
        formCustomerAddressHasErrors(value) {
            if(!value && !this.formCustomerCommunicationErrors) {
                this.$emit('step-product-customer-data-is-valid');
            } else {
                this.$emit('step-product-customer-data-has-errors');
            }
        },
        formBillAddressHasErrors(value) {
            if(value) {
                this.$emit('step-product-customer-data-has-errors');
            } else {
                this.$emit('step-product-customer-data-is-valid');
            }
        },
        formDeliveryAddressHasErrors(value) {
            if(value) {
                this.$emit('step-product-customer-data-has-errors');
            } else {
                this.$emit('step-product-customer-data-is-valid');
            }
        },
        formCustomerCommunicationErrors(value) {
            if(!value && !this.formCustomerAddressHasErrors) {
                this.$emit('step-product-customer-data-is-valid');
            } else {
                this.$emit('step-product-customer-data-has-errors');
            }
        },
        formBillCommunicationHasErrors(value) {
            if(value) {
                this.$emit('step-product-customer-data-has-errors');
            } else {
                this.$emit('step-product-customer-data-is-valid');
            }
        },
        formDeliveryCommunicationHasErrors(value) {
            if(value) {
                this.$emit('step-product-customer-data-has-errors');
            } else {
                this.$emit('step-product-customer-data-is-valid');
            }
        },
        formNotificationErrors(value) {
            if(value) {
                this.$emit('step-product-customer-data-has-errors');
            } else {
                this.$emit('step-product-customer-data-is-valid');
            }
        },
    },
};
